// extracted by mini-css-extract-plugin
export default {"button":"EditButton_button__+CB8-"};